import Vue       from "vue";
import Vuex      from "vuex";
Vue.use(Vuex);

import store     from "./store";
import Cookies   from "js-cookie";

var $ = $ || {};
var BX = BX || {};

window.Cookies=Cookies;
window.Vue    =Vue;

function number_format( number, decimals, dec_point, thousands_sep )
{
    var i, kw, kd;
    if( isNaN(decimals=Math.abs(decimals)) )
    {
        decimals=2;
    }
    if( dec_point == undefined )
    {
        dec_point=",";
    }
    if( thousands_sep == undefined )
    {
        thousands_sep=".";
    }
    i =parseInt(number=( +number || 0 ).toFixed(decimals)) + "";
    kw=i.split(/(?=(?:\d{3})+$)/).join(thousands_sep);
    kd=( decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "" );
    return kw + kd;
}

window.plural = function( number, words )
{
    let n=Math.abs(number);
    n%=100;
    if( n >= 5 && n <= 20 )
    {
        return words[ 2 ];
    }
    n%=10;
    if( n === 1 )
    {
        return words[ 0 ];
    }
    if( n >= 2 && n <= 4 )
    {
        return words[ 1 ];
    }
    return words[ 2 ];
}

Vue.filter("phoneFormat", phone =>
{
    phone=phone.replace(/[^\d]/g, "");
    if( phone.length != 11 )
    {
        return phone;
    }
    return phone.replace(/\d(\d{3})(\d{3})(\d{2})(\d{2})/, "8-$1-$2-$3-$4");
});

Vue.filter("plural", function( value, words )
{
    return window.plural(value, words);
});

Vue.filter("numberFormat", function( value )
{
    return number_format(value, 0, ".", " ");
});

Vue.filter("priceFormat", function( v ) {
    return number_format(v, 2, ".", " ").replace('.00', '');
});



import Quantity from "./components/Quantity.vue";
Vue.component("quantity", Quantity);

import CatalogItem from "./components/CatalogItem.vue";
Vue.component("catalog-item", CatalogItem);

import HeaderSearch from "./components/HeaderSearch.vue";
Vue.component("header-search", HeaderSearch);

import HeaderMessage from "./components/HeaderMessage.vue";
Vue.component("header-message", HeaderMessage);

import CartPreview from "./components/CartPreview.vue";
Vue.component("cart-preview", CartPreview);

Vue.component("authorization", () => import("./components/Authorization.vue"));
Vue.component("shops", () => import("./components/Shops.vue"));
Vue.component("availability", () => import("./components/Availability.vue"));
Vue.component("order-form", () => import("./components/OrderForm.vue"));
Vue.component("product", () => import("./components/Product.vue"));
Vue.component("tabs", () => import("./components/Tabs.vue"));
Vue.component("popup", () => import("./components/Popup.vue"));
Vue.component("input-mask", () => import("./components/InputMask.vue"));
Vue.component("input-phone", () => import("./components/InputPhone.vue"));
Vue.component("input-date", () => import("./components/InputDate.vue"));
Vue.component("input-address", () => import("./components/InputAddress.vue"));
Vue.component("cart", () => import("./components/Cart.vue"));
Vue.component("cart-card", () => import("./components/CartCard.vue"));
Vue.component("catalog-section", () => import("./components/CatalogSection.vue"));
Vue.component("ya-share", () => import("./components/YaShare.vue"));
Vue.component("addresses", () => import("./components/Addresses.vue"));


if( window.frameCacheVars !== undefined ) {
    window.BX.addCustomEvent("onFrameDataReceived", function( /* json */ ) {
        afterCompositeLoaded();
    });
}
else {
    if( window.BX ) {
        window.BX.ready(() => { afterCompositeLoaded(); });
    }
    else {
        document.addEventListener('DOMContentLoaded', () => afterCompositeLoaded());
    }
}

function onCompositeFail()
{
    if( ~window.location.href.indexOf("?") )
    {
        window.location.href=window.location.href + "&ncc=1";
    }
    else
    {
        window.location.href=window.location.href + "?ncc=1";
    }
}

window.BX.addCustomEvent("onFrameDataRequestFail", function( /* response */ )
{
    onCompositeFail();
});
if( !~window.location.href.indexOf("ncc=1") )
{
    window.compositeFailTimeout=setTimeout(
        function()
        {
            onCompositeFail();
        },
        5000,
    );
}

function afterCompositeLoaded()
{
    clearTimeout(window.compositeFailTimeout);
    window.App = new Vue({
        store,
        el : "#app",
        data : {
            processed : false,
            headerMessageTimeout : null,
            headerMessage : '',
        },
        computed : {
            favoriteProductIds () {
                return ((this.$store.state.initData || {}).UF_FAVORITE_PRODUCTS || []).map(id => +id);
            },
            cartItems () {
                return this.$store.state.cart.items || [];
            },
            cartSum () {
                return this.$store.state.cart.sum || 0;
            },
            userData () {
                return this.$store.state.initData.userData || {};
            },
            isAuthorized()
            {
                return !!this.$store.state.initData.userData.ID;
            },
        },
        mounted () {
            this.$store.dispatch('loadInitData');
            if (typeof(window.contentLoaded) == 'function') {
                setTimeout(() => {
                    window.contentLoaded();
                }, 1000);
            }
        },
        methods  : {
            initMap() {
                return new Promise(resolve => {
                    if( typeof(window.ymaps) == 'undefined' ) {
                        window.ymaps = null;
                        var script =document.createElement("script");
                        script.src ="https://api-maps.yandex.ru/2.1/?lang=ru_RU";
                        script.onload=() => {
                            window.ymaps.ready(() => {
                                resolve();
                            });
                        };
                        document.body.appendChild(script);
                    }
                    else if (window.ymaps)
                    {
                        window.ymaps.ready(() => {
                            resolve();
                        });
                    }
                });
            },
            initRecaptcha() {
                var script =document.createElement("script");
                script.src ="https://www.google.com/recaptcha/api.js?render=" + this.$store.state.recaptchaSiteKey;
                script.onload = () => {
                    window.grecaptcha.ready(() => {
                        $("form").on("click", e => {
                            var $form =$(e.currentTarget);
                            var $input=$form.find("[name=\"recaptcha_token\"]");
                            var action=$input.data("action-id");
                            if( !$input.val() && !$input.hasClass("recaptcha-processed") )
                            {
                                $input.addClass("recaptcha-processed");
                                window.grecaptcha.execute(this.$store.state.recaptchaSiteKey, {
                                    action,
                                }).then(token => {
                                    $($input).val(token);
                                });
                            }
                        });
                    });
                };
                document.body.appendChild(script);
            },
            setLoader( processed = true ) {
                this.processed = processed;
            },
            showMessage( message ) {
                if( !message ) {
                    return;
                }
                return new Promise(( resolve ) =>
                {
                    this.message = message;
                    let popupCheckInterval=setInterval(() => {
                        if( this.$refs.Popup ) {
                            clearInterval(popupCheckInterval);
                            this.$refs.Popup.open()
                            .then(action => {
                                resolve(action);
                            });
                        }
                    }, 1000);
                });
            },
            showHeaderMessage( message, delay = 3000 ) {
                if( !message ) {
                    return;
                }
                return new Promise(( resolve ) =>
                {
                    clearTimeout(this.headerMessageTimeout);
                    this.headerMessage = message;
                    this.headerMessageTimeout = setTimeout(() => {
                        this.headerMessage = '';
                    }, delay);
                    resolve();
                });
            },
            sendSmsCode(phone) {
                return new Promise(( resolve ) => {
                    phone = phone.replace(/[^\d]/g, "");
                    fetch(`/ajax/v1/send-sms-code/${phone}/`, {
                        method : "POST",
                    })
                    .then(res => res.json())
                    .then(res => {
                        resolve(res);
                    });
                });
            },
            alert( message, status = 'success' ) {
                this.$refs.HeaderMessage.alert(message, status);
            },
            cookie( name, val, options={} ) {
                if ( typeof ( val ) == "undefined" ) {
                    let val = Cookies.get(name);
                    try {
                        val = JSON.parse(val);
                    } catch (e) {
                        console.error(e);
                    }
                    return val;
                }
                else {
                    Cookies.set(name, val, Object.assign({expires : 30}, options));
                }
            },
        },
    });
}
